export default "<p>room-allotment works!</p>\n";